export default function toggleInputBoxToState(settings, disabled): void {
    const inputBoxes = Array.from(document.getElementsByClassName(settings.classNames.inputboxTextAreaClassName));

    inputBoxes.forEach(textArea => {
        // If disable happens quickly this does not get picked up.  Also set/remove attribute..
        (textArea as HTMLTextAreaElement).disabled = disabled;
        if (disabled) {
            (textArea as HTMLTextAreaElement).setAttribute('disabled', 'true');
        } else {
            (textArea as HTMLTextAreaElement).removeAttribute('disabled');
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/element-disabler/src/disablers/inputBox.ts